import { useState,useCallback } from "react";
export default function useDashboardRefresh() {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshDashboard = useCallback(async () => {
    setIsRefreshing(true);
    setRefreshTrigger(prev => prev + 1);
    // Add a small delay to ensure state updates propagate
    await new Promise(resolve => setTimeout(resolve, 100));
    setIsRefreshing(false);
  }, []);

  return { refreshTrigger, isRefreshing, refreshDashboard };
}


